module.exports = __webpack_public_path__ + "static/media/keterangan_sehat.1af11e5d.jpg";